import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const Wrapper = styled(FlexBox)<{ reverse?: boolean }>`
    flex-flow: column-reverse;
    width: 100%;

    .remove-lang-button {

        &:hover {
            color: #545453;
            transition: color: 0.2s;
        }
    }
`;

export const DeleteButton = styled.div<{ isCompetitionEdit?: boolean }>`
    font-family: 'Inter';
    font-size: 15px;
    line-height: 20px;
    color: #909090;
    font-weight: 400;
    white-space: nowrap;
    margin-top: 16px;
    cursor: pointer;

    ${({ isCompetitionEdit }) => isCompetitionEdit && css`
        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            font-size: 13px;
            line-height: 16px;
            margin-top: 8px;
        }
    `};
`;import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const Wrapper = styled(FlexBox)<{ reverse?: boolean }>`
    flex-flow: column-reverse;
    width: 100%;

    .remove-lang-button {

        &:hover {
            color: #545453;
            transition: color: 0.2s;
        }
    }
`;

export const DeleteButton = styled.div<{ isCompetitionEdit?: boolean }>`
    font-family: 'Inter';
    font-size: 15px;
    line-height: 20px;
    color: #909090;
    font-weight: 400;
    white-space: nowrap;
    margin-top: 16px;
    cursor: pointer;

    ${({ isCompetitionEdit }) => isCompetitionEdit && css`
        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            font-size: 13px;
            line-height: 16px;
            margin-top: 8px;
        }
    `};
`;